// src/components/Layout.js
import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
// import Footer from "./Footer";
import Header from "../Header/Header";

const Layout = () => {
  return (
    <div className="vh-100 dashboardView d-flex">
      {/* Sidebar */}
      <div className="leftSideBar">
        <Sidebar />
      </div>

      {/* Main Section */}
      <div className="rightSideBar background-color-body flex-grow-1 d-flex flex-column">
        
        {/* Header (not fixed, just inline at the top) */}
        {/* <div className="p-3">
          <Header />
        </div> */}

        {/* Page Content */}
        <div className="flex-grow-1 overflow-auto">
          <Outlet />
        </div>

        {/* Footer (optional, only if you want at bottom) */}
        {/* <Footer /> */}
      </div>
    </div>
  );
};

export default Layout;
